module.exports = __webpack_public_path__ + "static/media/Logo.40607dc5.png";